import { TeamHelpers } from 'helpers/TeamHelpers';

import { useCurrentTeam } from './use-current-team';

const useCurrentTeamSubscription = () => {
    const team = useCurrentTeam();

    return TeamHelpers.getDesignerSubscription(team);
};

export { useCurrentTeamSubscription };
